import React from 'react'
import Slider from 'react-slick'
import { Text, ClientBox, ServiceBox, ServiceImageBox, TextClient, TextService } from '../../common/styled'
import Icon, { FontAwesome } from 'react-web-vector-icons'
import mediaQuery from '../../common/mediaQuery'
import '../style.css'

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className="arrow"
      style={{ ...style, display: "flex", background: "transparent", margintLeft: "2vw", cursor: "pointer"}}
      onClick={onClick}
    >
      <FontAwesome
        name='chevron-right'
        color='#222'
        size={30}
      />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className="arrow"
      style={{ ...style, display: "flex", background: "transparent", margintRight: "2vw", cursor: "pointer"}}
      onClick={onClick}
    >
      <FontAwesome
        name='chevron-left'
        color='#222'
        size={30}
      />
    </div>
  );
}

export default ({ text, language }) => {
  
  const { small } = mediaQuery()

  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow:  language === 'br' ? small ? 1 : 4 : small ? 1 : 2,
    draggable: true,  
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    className: "EmployeeSlider"
  }

  return (
    <div className="ClientContainer">
      <div className="SlideClientContainer">
        <Slider {...settings}>
          {text.getClientesDev().map(box => {
            return (
              <div>
                <ClientBox width={small ? "75vw" : "18vw"}>
                  <div style={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center' }}>
                    <ServiceImageBox width={small ? "60vw" : "16vw"}>
                      <img className={"ServiceImage"} src={box.image} alt="" />
                    </ServiceImageBox>
                  </div>
                  
                  <div style={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center' }}>
                    <ServiceBox width={small ? "60vw" : "16vw"}>
                      <TextService color="#22222280" size="2vh" weight="700">{ box.cliente }</TextService>
                      <TextClient color="#22222280" size="2vh" weight="700">{ box.projeto }</TextClient>
                    </ServiceBox>
                  </div>
                </ClientBox>
              </div>
            )
          })}
        </Slider>
      </div>
    </div>
  )
}